// Copyright (c) 2017 Deere & Company

export default Object.freeze({
    READ_CLAIM_SUMMARY_SUCCESS: 'READ_CLAIM_SUMMARY_SUCCESS',
    READ_REIMBURSEMENT_SUMMARY_SUCCESS: 'READ_REIMBURSEMENT_SUMMARY_SUCCESS',
    RESET_REIMBURSEMENT_SUMMARY_SELECTED_LEAD_ACCOUNT: 'RESET_REIMBURSEMENT_SUMMARY_SELECTED_LEAD_ACCOUNT',
    UPDATE_REIMBURSEMENT_SUMMARY_DETAILS_ROW_DATA: 'UPDATE_REIMBURSEMENT_SUMMARY_DETAILS_ROW_DATA',
    UPDATE_REIMBURSEMENT_SUMMARY_IS_INITIAL_LOAD: 'UPDATE_REIMBURSEMENT_SUMMARY_IS_INITIAL_LOAD',
    UPDATE_REIMBURSEMENT_SUMMARY_SELECTED_LEAD_ACCOUNT: 'UPDATE_REIMBURSEMENT_SUMMARY_SELECTED_LEAD_ACCOUNT',
    UPDATE_REIMBURSEMENT_SUMMARY_SELECTED_POSTING_DATE: 'UPDATE_REIMBURSEMENT_SUMMARY_SELECTED_POSTING_DATE',
    UPDATE_REIMBURSEMENT_SUMMARY_SELECTED_VALUE: 'UPDATE_REIMBURSEMENT_SUMMARY_SELECTED_VALUE'
});



// WEBPACK FOOTER //
// ./src/reimbursement-summary/actions-list.js